import React from "react";

const Administracion = () => {
  return (
    <div>
      <ul class="list-group">
        <li class="list-group-item d-flex justify-content-between align-items-center">
          <a class="nav-link text-dark" href="/admin/slide">
            Slider Principal
          </a>
          <span class="badge badge-pill">
            <i class="fa fa-cloud-upload fa-2x" aria-hidden="true"></i>
          </span>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-center">
          <a class="nav-link text-dark" href="/admin/producto">
            Productos
          </a>
          <span class="badge badge-pill">
            <i class="fa fa-cog fa-2x" aria-hidden="true"></i>
          </span>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-center">
          <a class="nav-link text-dark" href="/admin/promocion">
            Promociones
          </a>
          <span class="badge badge-pill">
            <i class="fa fa-bell-o fa-2x" aria-hidden="true"></i>
          </span>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-center">
          <a class="nav-link text-dark" href="/#">
            Mas
          </a>
          <span class="badge badge-pill">
            <i class="fa fa-plus-circle fa-2x" aria-hidden="true"></i>
          </span>
        </li>
      </ul>
    </div>
  );
};

export default Administracion;
